import SpotTheElementSheet from './SpotTheElementSheet';
import FizzOrNoFizzSheet from './FizzOrNoFizzSheet';
import MetalsSortSheet from './MetalsSortSheet';
import LabNotebookSheet from './LabNotebookSheet';
import AlkaliMetalsSheet from './AlkaliMetalsSheet';
import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { WORKSHEET_KINDS } from '../../data/worksheets';

const SHEETS_BY_KIND = Object.freeze({
  [WORKSHEET_KINDS.SPOT_THE_ELEMENT]: SpotTheElementSheet,
  [WORKSHEET_KINDS.FIZZ_OR_NO_FIZZ]: FizzOrNoFizzSheet,
  [WORKSHEET_KINDS.METALS_SORT]: MetalsSortSheet,
  [WORKSHEET_KINDS.LAB_NOTEBOOK]: LabNotebookSheet,
  [WORKSHEET_KINDS.ALKALI_METALS]: AlkaliMetalsSheet,
});

/**
 * The printable part of a worksheet: a name line plus the exercise, or its answer key.
 */
export default function WorksheetSheet({ worksheet, showAnswers = false }) {
  const Sheet = SHEETS_BY_KIND[worksheet.kind];
  return (
    <div className={WORKSHEET_CLASSES.sheet}>
      {!showAnswers && (
        <p className={WORKSHEET_CLASSES.nameLine}>
          Name: <span className={WORKSHEET_CLASSES.blankWide} /> Date: <span className={WORKSHEET_CLASSES.blank} />
        </p>
      )}
      <Sheet worksheet={worksheet} showAnswers={showAnswers} />
    </div>
  );
}
